<template>
  <el-upload
    ref="upload"
    class="upload-demo"
    :action="httpBaseURL + uploadPath"
    :data="uploadData"
    :before-upload="beforeAvatarUpload"
    :on-change="handleChange"
    :on-remove="(file, fileLists) => handleRemove && handleRemove(file, fileLists)"
    :on-success="(res, file, fileLists) => handleAvatarSuccess(res, file, fileLists)"
    :before-remove="beforeRemove"
    multiple
    :limit="limit"
    :on-exceed="handleExceed"
    :auto-upload="autoUpload"
    :file-list="fileList"
    :disabled="disabled">
    <el-button size="small" type="primary" :disabled="disabled">点击上传</el-button>
    <div slot="tip" class="el-upload__tip">附件上传（{{limit}}个，单个附件限制20m）</div>
  </el-upload>
</template>

<script>
export default {
  name: 'uploadFile',
  data () {
    return {
      uploadData: {
        TOKEN_KEY: localStorage.getItem('token')
      }
    }
  },
  props: ['refs', 'fileList', 'handleRemove', 'handleAvatarSuccess', 'limit', 'acceptType', 'autoUpload', 'disabled'], // 接收父组件的方法
  computed: {
    httpBaseURL () {
      return this.$global.httpBaseURL
    },
    uploadPath () {
      return this.$global.uploadPath
    }
  },
  watch: {
  },
  mounted () {
    if (this.$refs.upload) {
      this.$emit('update:refObj', this.$refs.upload)
    }
  },
  methods: {
    handleChange (file, fileList) {
      // 如果有限制上传类型 在选择文件时 判断文件类型
      let isType = true
      let suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (this.acceptType) {
        isType = this.acceptType.indexOf(suffix) !== -1
      }
      if (!isType) {
        this.$message.error('请上传后缀名为' + this.acceptType.join(',') + '的文件')
        this.fileList.pop()
      }
    },
    beforeAvatarUpload (file, fileList) {
      let isType = true
      let suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (this.acceptType) {
        isType = this.acceptType.indexOf(suffix) !== -1
      }
      if (!isType) {
        this.$message.error('请上传后缀名为' + this.acceptType.join(',') + '的文件')
      }
      let isSize = (file.size / 1024 / 1024) < 20
      if (!isSize) {
        this.$message.error('上传单个附件限制20m')
      }
      return isType && isSize
    },
    handleExceed (files, fileList) {
      this.$message.warning('当前限制选择 ' + this.limit + ' 个文件，本次选择了' + files.length + '个文件，共选择了' + fileList.length + '个文件')
    },
    beforeRemove (file, fileList) {
      let isSize = (file.size / 1024 / 1024) < 2
      let isType = true
      let suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (this.acceptType) {
        isType = this.acceptType.indexOf(suffix) !== -1
      }
      if (isType && isSize) {
        return this.$confirm('确定移除' + file.name + '?')
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UploadFile.vue